import React, { useEffect, useState, useRef, lazy } from 'react';
import { Kicker, CharReveal } from './ui';
const IMG = (id: string) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=1000&q=80`;
const PROJECTS = [{
  name: 'Danfo Pay',
  cat: 'Fintech · Brand + App',
  from: '#f5c518',
  to: '#7a5e00',
  img: 'https://cdn.magicpatterns.com/uploads/86o7vQsikVwJ5Dinp1KJ1U/Danfo_Pay.png',
  alt: 'Commuter tapping a phone to pay a fare beside a yellow Lagos danfo bus'
}, {
  name: 'Ilé Homes',
  cat: 'Proptech · Web + Identity',
  from: '#9a9083',
  to: '#2e2a24',
  img: IMG('photo-1600585154340-be6161a56a0c'),
  alt: 'Modern residential architecture at dusk'
}, {
  name: 'Mọjú Skincare',
  cat: 'Beauty · Brand + Packaging',
  from: '#e0a9a0',
  to: '#5c2e2a',
  img: IMG('photo-1556228720-195a672e8a03'),
  alt: 'Minimal skincare bottle on a soft background'
}, {
  name: 'Harmattan Studio',
  cat: 'Media · Identity + Motion',
  from: '#c9b79c',
  to: '#3d3223',
  img: IMG('photo-1478737270239-2f02b77fc618'),
  alt: 'Broadcast microphone in a recording studio'
}, {
  name: 'Ojota Athletics',
  cat: 'Sportswear · Campaign',
  from: '#3e7c4f',
  to: '#12321d',
  img: IMG('photo-1552674605-db6ffd4facb5'),
  alt: 'Athlete running at golden hour'
}, {
  name: 'Suya Bar',
  cat: 'Food & Bev · Brand + Web',
  from: '#e4572e',
  to: '#701f0b',
  img: IMG('photo-1555939594-58d7cb561ad1'),
  alt: 'Grilled skewers over open flame'
}];
const N = PROJECTS.length;
export function Work() {
  const [active, setActive] = useState(0);
  const hovering = useRef(false);
  useEffect(() => {
    const id = setInterval(() => {
      if (!hovering.current) setActive(a => (a + 1) % N);
    }, 4500);
    return () => clearInterval(id);
  }, []);
  const go = (dir: number) => setActive(a => (a + dir + N) % N);
  return <section id="work" className="py-24 md:py-32 overflow-hidden" data-id="element-219">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 flex flex-wrap items-end justify-between gap-6" data-id="element-220">
        <div data-id="element-221">
          <Kicker ig="Ọ́rụ Ahọpụtara" en="Selected work" data-id="element-222" />
          <h2 className="font-display uppercase text-5xl md:text-8xl tracking-tight mt-4" data-id="element-223">
            <CharReveal text="Work" data-id="element-224" />
          </h2>
        </div>
        <div className="flex items-center gap-4" data-id="element-225">
          <span className="font-monoui text-xs tracking-[0.18em] opacity-60" data-id="element-226">
            0{active + 1} / 0{N}
          </span>
          <button onClick={() => go(-1)} aria-label="Previous project" className="flex h-12 w-12 items-center justify-center rounded-full border transition-colors hover:border-[var(--danfo)]" style={{
          borderColor: 'var(--line)'
        }} data-id="element-227">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true" data-id="element-228">
              <path d="M15 6L9 12L15 18" stroke="currentColor" strokeWidth="2.2" strokeLinecap="square" data-id="element-229" />
            </svg>
          </button>
          <button onClick={() => go(1)} aria-label="Next project" className="flex h-12 w-12 items-center justify-center rounded-full border transition-colors hover:border-[var(--danfo)]" style={{
          borderColor: 'var(--line)'
        }} data-id="element-230">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true" data-id="element-231">
              <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="2.2" strokeLinecap="square" data-id="element-232" />
            </svg>
          </button>
        </div>
      </div>

      <div className="relative mt-12 md:mt-16 h-[440px] md:h-[600px]" style={{
      perspective: '1500px'
    }} onMouseEnter={() => hovering.current = true} onMouseLeave={() => hovering.current = false} data-id="element-233">
        {PROJECTS.map((p, i) => {
        let off = i - active;
        if (off > N / 2) off -= N;
        if (off < -N / 2) off += N;
        const abs = Math.abs(off);
        const visible = abs <= 2;
        const isActive = off === 0;
        return <button key={p.name} onClick={() => setActive(i)} aria-label={`View ${p.name}`} className="absolute left-1/2 top-1/2 w-[260px] md:w-[400px] aspect-[4/5] rounded-2xl overflow-hidden text-left" style={{
          background: `linear-gradient(150deg, ${p.from}, ${p.to})`,
          zIndex: 30 - abs,
          opacity: visible ? 1 : 0,
          pointerEvents: visible ? 'auto' : 'none',
          transform: `translate(-50%, -50%) translateX(${off * 72}%) translateZ(${-abs * 190}px) rotateY(${-off * 26}deg)`,
          transition: 'transform 0.85s cubic-bezier(0.2, 0.8, 0.2, 1), opacity 0.4s ease',
          transformStyle: 'preserve-3d'
        }} data-id="element-234">
              <img src={p.img} alt={p.alt} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-all duration-700" style={{
            opacity: isActive ? 1 : 0.75,
            filter: isActive ? 'saturate(1)' : 'saturate(0.4)'
          }} data-id="element-235" />
              <span aria-hidden="true" className="absolute inset-0 transition-opacity duration-700" style={{
            background: `linear-gradient(150deg, ${p.from}55, ${p.to}88)`,
            mixBlendMode: 'multiply',
            opacity: isActive ? 0.55 : 0.95
          }} data-id="element-236" />
              <span aria-hidden="true" className="absolute inset-0" style={{
            background: 'linear-gradient(180deg, rgba(17,16,19,0) 40%, rgba(17,16,19,0.82))'
          }} data-id="element-237" />
              <span className="relative flex h-full flex-col justify-between p-6 md:p-8" style={{
            color: '#efeae3'
          }} data-id="element-238">
                <span className="font-monoui self-start text-[10px] md:text-[11px] uppercase tracking-[0.14em] rounded-full px-3.5 py-1.5" style={{
              background: 'rgba(17,16,19,0.55)',
              backdropFilter: 'blur(4px)'
            }} data-id="element-239">
                  {p.cat}
                </span>
                <span className="flex items-end justify-between gap-4" data-id="element-240">
                  <span className="font-display uppercase text-2xl md:text-4xl leading-tight tracking-tight" data-id="element-241">
                    {p.name}
                  </span>
                  <span aria-hidden="true" className="font-monoui shrink-0 text-xs md:text-sm transition-opacity duration-500" style={{
                color: 'var(--danfo)',
                opacity: isActive ? 1 : 0
              }} data-id="element-242">
                    View ↗
                  </span>
                </span>
              </span>
            </button>;
      })}
      </div>

      <p className="mt-10 text-center font-monoui text-[11px] uppercase tracking-[0.18em] opacity-40" data-id="element-243">
        Click a card or use the arrows
      </p>
    </section>;
}